export const educationData = [
    {
        id: 1,
        institution: 'BMIIT | Babu Madhav Institute of Information Technology - UTU',
        course: 'Bachelor Degree in (Bsc.it)',
        startYear: '2020',
        endYear: 'Present'
    },
    {
        id: 2,
        institution: 'Shree Swaminarayan Gurukul',
        course: 'Higher Secondary',
        startYear: '2018',
        endYear: '2020'
    },
    {
        id: 3,
        institution: 'Gajera International School, Katargam - Surat ',
        course: 'Secondary School',
        startYear: '2008',
        endYear: '2018'
    },
]